import { compose, withState, withHandlers, branch, renderComponent } from 'recompose';

import MergeDuplicates from './MergeDuplicates';

export default compose(
  withState('isMobileSurvivingCustomer', 'setIsMobileSurvivingCustomer', false),
  withState('survivingCustomerId', 'setSurvivingCustomerId', null),
  withState('customerIds', 'setCustomerIds', null),
  withHandlers({
    resetSelectedForMerge: props => () => {
      props.setCustomerIds(null);
      props.setSurvivingCustomerId(null);
      props.setIsMobileSurvivingCustomer(false);
    },
  }),
  branch(
    props => props.survivingCustomerId,
    renderComponent(MergeDuplicates),
  )
);
